export enum TIMESLICE_TABLE_COLUMNS {
    NAME = 'Name',
    TYPE = 'Type',
    REPETITION = 'Repetition',
    INCLUDEEXCLUDE = 'IncludeExclude',
    DETAILS = 'Details',
    TIME = 'Time',
    TEMPORARY = 'Temporary',
    ACTIONS = 'Actions',
}

export const TIMESLICE_DEFAULT_SORT_COLUMN = TIMESLICE_TABLE_COLUMNS.NAME;
export const TIMESLICE_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
export const TIMESLICE_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const TIMESLICE_PAGE_DEFAULT_SIZE = 20;
export const TIMESLICE_MAX_MEMORY_SIZE = 20;

export const TIMESLICE_TABLE_HEADER = [
    TIMESLICE_TABLE_COLUMNS.NAME,
    TIMESLICE_TABLE_COLUMNS.TYPE,
    TIMESLICE_TABLE_COLUMNS.REPETITION,
    TIMESLICE_TABLE_COLUMNS.INCLUDEEXCLUDE,
    TIMESLICE_TABLE_COLUMNS.DETAILS,
    TIMESLICE_TABLE_COLUMNS.TIME,
    TIMESLICE_TABLE_COLUMNS.TEMPORARY,
    TIMESLICE_TABLE_COLUMNS.ACTIONS,
];



export enum RULE_TABLE_COLUMNS {
    NAME = 'Name',
    TIMESLOT = 'Timeslot',
    SPECIALPERIOD = 'SpecialPeriod',
    ACTIONS = 'Actions',
}

export const RULE_DEFAULT_SORT_COLUMN = RULE_TABLE_COLUMNS.NAME;
export const RULE_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
export const RULE_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const RULE_PAGE_DEFAULT_SIZE = 20;
export const RULE_MAX_MEMORY_SIZE = 20;

export const RULE_TABLE_HEADER = [
    RULE_TABLE_COLUMNS.NAME,
    RULE_TABLE_COLUMNS.TIMESLOT,
    RULE_TABLE_COLUMNS.SPECIALPERIOD,
    RULE_TABLE_COLUMNS.ACTIONS,
];




export const SPECIALPLANNINGS_FLAGS_ACCESS_EXCLUDED = 128
export const SPECIALPLANNINGS_FLAGS_ACCESS_INCLUDED = 129